import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authAxios } from "../utils/axiosConfig";

const initialState = {
	firstname: null,
	lastname: null,
	id: null,
	role: null,
	gender: null,
	address: null,
	isLoggedIn: false,
	isLoading: false,
	error: null,
};

// USING REDUX THUNK
export const login = createAsyncThunk(
	"auth/login",
	async ({ email, password }, thunkAPI) => {
		try {
			const response = await authAxios.post("/auth/login", {
				email,
				password,
			});
			const { userData, accessToken, message } = response.data;

			if (!response) {
				toast.error("SERVER --> ERROR");
			}

			localStorage.setItem("accessToken", accessToken);

			const id = userData.id;
			const firstname = userData.firstname;
			const lastname = userData.lastname;
			const role = userData.role;
			const gender = userData.gender;
			const address = userData.address;

			const userInfo = { id, firstname, lastname, role, gender, address };

			return { userInfo, accessToken, message };
		} catch (error) {
			console.error("ERROR_DATA ", error.response.data);

			return thunkAPI.rejectWithValue(error.response?.data);
		}
	}
);

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		logout(state) {
			state.user = null;
			state.isLoggedIn = false;
			state.isLoading = false;
			state.error = null;
			state.accessToken = null;
			localStorage.removeItem("accessToken");
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(login.pending, (state) => {
				state.isLoggedIn = false;
				state.isLoading = true;
				state.error = null;
			})
			.addCase(login.fulfilled, (state, action) => {
				state.firstname = action.payload.userInfo.firstname;
				state.lastname = action.payload.userInfo.lastname;
				state.id = action.payload.userInfo.id;
				state.role = action.payload.userInfo.role;
				state.gender = action.payload.userInfo.gender;
				state.address = action.payload.userInfo.address;
				state.isLoggedIn = true;
				state.isLoading = false;
				state.error = null;
				state.accessToken = action.payload.accessToken;
			})
			.addCase(login.rejected, (state, action) => {
				state.isLoggedIn = false;
				state.isLoading = false;
				state.error = action.payload;
			});
	},
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
